import React from "react";
import {FormControlLabel, Grid, Radio, RadioGroup, TextareaAutosize} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";
import i18n from "../../../../i18nextInitiator";
import Button from "@material-ui/core/Button";
import {cancelOrder, setCancelReason} from "../../../../actions/actionCreators";
import {connect} from "react-redux";
import {SET_CANCEL_TEXTAREA} from "../../../../actions/actionsTypes";

/**
 * the translate function.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');
/**
 * styles.
 * @type {(props?: any) => ClassNameMap<"root"|"card">}
 */
const useStyles = makeStyles((theme) => ({
    radioGroup: {
        width: "100%"
    },
    radioItem: {
        borderBottom: "1px solid #D8D8D8"
    },
    textarea: {
        width: "100%",
        borderRadius: ".8rem",
        borderColor: theme.palette.primary.border,
        backgroundColor: theme.palette.primary.light,
        padding: "1rem"
    },
    submitBtn: {
        color: "#fff",
        backgroundColor: theme.palette.error.main,
        border: "1px solid rgba(0, 0, 0, 0.23)",
        padding: "5px 15px",
        borderRadius: ".8rem",
    }
}))
/**
 * maps redux states to component props
 * @param state
 */
const mapStateToProps = state => ({...state})

const mapDispatchToProps = dispatch => ({
    showTextarea: (value) => dispatch({type: SET_CANCEL_TEXTAREA, value})
})

/**
 * Cancel Modal Component.
 * @returns {JSX.Element}
 * @constructor
 */
const CancelModal = (props) => {
    const classes = useStyles()
    const {
        showTextarea,
        order: {
            cancelReason,
            cancelTextarea
        }
    } = props

    const handleChangeRadio = (event) => {
        const {target: {value}} = event
        const showTextArea = value === 'other'
        showTextarea(showTextArea)
        setCancelReason(value)
    };

    const handleChangeTextarea = e => {
        const {target: {value}} = e
        setCancelReason(value)
    }

    const handleSubmit = () => {
        cancelOrder(cancelReason)
        props.close()
    }

    return <>
        <Grid item xs={12}>
            <Typography>{t('canceling.desc')}</Typography>
        </Grid>

        <RadioGroup className={classes.radioGroup} value={cancelReason} onChange={handleChangeRadio}>
            {
                Array(7).fill("canceling.choices.").map((item, key) => {
                    return <FormControlLabel key={key} className={classes.radioItem} value={t(item + key)}
                                             control={<Radio/>} label={t(item + key)}/>
                })
            }
            <FormControlLabel value={"other"} checked={cancelTextarea} control={<Radio/>} label={t("canceling.other-reasons")}/>
        </RadioGroup>

        {
            cancelTextarea &&
            <TextareaAutosize onChange={handleChangeTextarea} className={classes.textarea} rowsMin={3}
                              placeholder={t("canceling.other-reasons-placeholder")}/>
        }

            <Button
                disabled={!cancelReason || cancelReason === 'other'}
                onClick={handleSubmit}
                className={classes.submitBtn}
                variant={"contained"}
                size={"large"}
                fullWidth>
                {t('cancel-order')}
            </Button>

    </>
}


export default connect(mapStateToProps, mapDispatchToProps)(CancelModal)
